import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import ReactHighcharts from 'react-highcharts';
import {injectIntl} from 'react-intl';

const styles = {
  wrapper: {
    padding: 15
  },
};

class NpsByHourOfDayBarChart extends Component {
  render() {
    const intl = this.props.intl;
    const answersReport = this.props.answersReport;
    const npsByHourOfDay = answersReport ? answersReport.npsByHourOfDay : [];

    const categories = npsByHourOfDay.map(item => item.hour);
    const data = npsByHourOfDay.map(item => item.nps);

    const chartConfig = {
      chart: {
        type: 'column',
        height: this.props.height-(styles.wrapper.padding*2),
        width: this.props.width-(styles.wrapper.padding*2),
        marginLeft: 20,
        marginRight: 20,
      },
      title: {
        text: intl.formatMessage({id: 'nps'}),
        margin: 5,
        style: {
          fontSize: '14px',
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        formatter: function() {
          const index = categories.findIndex(x => x === this.x);
          return intl.formatMessage({
            id: 'numberOfAnswers',
          },{
            count: npsByHourOfDay[index].count,
          });
        },
      },
      xAxis: {
        categories,
        title: {
          text: intl.formatMessage({id: 'hourOfDay'}),
        },
      },
      yAxis: {
        visible: false,
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true,
            format: '{y:.0f}',
          },
          pointPadding: 0,
          groupPadding: 0.1,
        },
      },
      series: [{
        data,
      }],
    };
    return (
      <div style={styles.wrapper}>
        <ReactHighcharts
          config={chartConfig}
          domProps={{id: this.props.uniqueId}}
        />
      </div>
    );
  }
}

export default createFragmentContainer(
  injectIntl(NpsByHourOfDayBarChart),
  graphql`
    fragment NpsByHourOfDayBarChart_answersReport on AnswersReport {
      npsByHourOfDay {
        hour
        nps
        count
      }
    }
  `,
);



// WEBPACK FOOTER //
// ./src/components/NpsByHourOfDayBarChart/NpsByHourOfDayBarChart.js